import {Component, Input, NgZone, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CommentService} from "../../../../../service/comment.service";
import * as _ from 'lodash';
import {Router} from "@angular/router";
import {environment} from "../../../../../../environments/environment";
import {UserService} from "../../../../../service/user.service";
import { eventEmitterService } from '../../../../../service/eventEmitter.service';
import { PercentageIncreaseUpdaterService } from '../../../../../service/percentage-increase-updater.service';
import { FeedService } from '../../../../../service/feed.service';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-reply',
  templateUrl: './reply.component.html',
  styleUrls: ['./reply.component.css']
})
export class ReplyComponent implements OnInit, OnDestroy {

  @Input('commentId') commentId;
  @Input('replyId') replyId;
  @Input('activityId') activityId;
  @Input() feedType;
  @Input() isBuildingHasBuildingManager;


  id = localStorage.getItem('residents');
  isManager = localStorage.getItem('isManager');
  userBuildingId = localStorage.getItem('userBuildingId');
  userType = localStorage.getItem('type');
  replyData;
  loadedReplyData;
  isLoading = false;
  repliesData:any = {};
  oldReplyData;
  differenceData;
  replyForm: FormGroup;
  editReplyForm: FormGroup;
  replySubject = new Subject();
  timer: Subscription;

  flagReplyUserList = [];
  flagReplyIdList = [];
  //isBuildingHasBuildingManager = false;

  environmentUrl = environment.apiUrl;
  s3apiUrl = environment.s3BucketApi;

  isFieldEmpty = true;
  isEditReplyEmpty = false;

  // Lazy load, pagination vars
  initialSkip = 0;
  skip = 0;
  limit = 3;
  loadMoreCounter = 0;
  loadMore = true;
  latestReplies;
  oldReplyLength = 0;
  newReplyLength = 0;

  constructor(private commentService: CommentService,
              private fb: FormBuilder,
              private ngZone: NgZone,
              private router: Router,
              private _feed: FeedService,
              private userService: UserService,
              private chatService : eventEmitterService,
              private percentageService : PercentageIncreaseUpdaterService) { }

  ngOnInit() {

    this._feed._feed$.subscribe((feedsRes) => {
      if(feedsRes['replies']){
       
          if(this.commentId === (feedsRes['replies'].comment.id || feedsRes['replies'].comment)){
            if(feedsRes['replies'].delete){            
              this.replyData = this.replyData.filter(function(element){
                if(element.id === feedsRes['replies'].id){
                  return false;
                }else{
                  return true;
                }
        
              });
              this.chatService.replyCount$.next(feedsRes['replies']);
              
            }else{
              if(feedsRes['replies'].update){
                this.replyData = this.replyData.map(function(item) { return item.id == feedsRes['replies'].id ? feedsRes['replies'] : item; });                
                if(feedsRes['replies'].flag){
                  this.chatService.replyCount$.next(feedsRes['replies']);
                }
              }else{
                this.chatService.replyCount$.next(feedsRes['replies']);                              
                this.replyData.unshift(feedsRes['replies'])              
              }
              this.replyData = this.replyData.filter((v, i, a) => i === a.findIndex((t) => (
                t.id === v.id )));
            }

          }
      
      }
    });


    this.replyForm =  this.fb.group({
      reply: ['', Validators.compose([Validators.required])],
    });

    this.editReplyForm =  this.fb.group({
      reply: ['', Validators.compose([Validators.required])],
    });


    //console.log('Comment activity ID : ', this.commentId);
    this.replyData = [];
    this.commentService.getAllRepliesByComment(this.commentId).subscribe(
      (allReplies) => {
        if (this.limit >= allReplies.length) {
          this.loadMore = false;
        }
        this.commentService.getRepliesByComment(this.commentId, this.initialSkip, this.limit).subscribe(
          (replies) => {
            //console.log('Replies for Comment ID : ' + this.commentId, replies);
            this.oldReplyData = replies;
            this.replyData = replies;
            this.oldReplyLength = replies.length;
          }
        );
      }
    );

    // this.replySubject.subscribe(
    //   (replies) => {
    //     this.replyData = replies;
    //     //console.log('Replies Data : ', this.replyData);
    //   }
    // );

    // if(this.isManager != 'true'){
    //   this.userService.isManagerExists(this.userBuildingId).subscribe(
    //     (building) => {
    //       //console.log('Is Building Manager Exists : ', building);
    //       var buildingManager = building.building[0].buildingManager;
    //       var resident = building.building[0].resident;
    //       if(_.isEmpty(buildingManager) || _.isUndefined(buildingManager)){
    //         this.isBuildingHasBuildingManager = false;
    //       }else {
    //         this.isBuildingHasBuildingManager = true;
    //       }
    //     }
    //   );
    // }

    this.commentService.getFlaggedReplyByUserId(this.id).subscribe(
      (replies) => {
        //console.log('Flasgged Replies : ', replies);
        this.flagReplyIdList = [];
        for(let reply of replies.replies){
          //console.log(reply);
          if(reply.isFlaggedBy.length > 0){
            this.flagReplyIdList.push(reply.id);
          }
        }
      }
    );

  }
  openChat(user){
    this.chatService.open(user);
 }

  ngOnDestroy() {
    if(this.timer){
      this.timer.unsubscribe();
    }
  }

  showContent(event){
    $(event).find('div.showmoredrp').toggle(500);

  }
  flagPostToggle(replyId, ele, flagType) {
    //$(ele).find('span').toggle();

    let type;

    if(this.feedType == 'post' || this.feedType == 'group' || this.feedType == 'recommendation' || this.feedType == 'marketplace'){
      type = 'Activityfeed';
    }else if(this.feedType == 'maintenance'){
      type = 'Maintanance';
    }else if(this.feedType == 'events'){
      type = 'Events';
    }

    this.commentService.flagReplyById(replyId, this.id, type, this.isManager, flagType, this.activityId).subscribe(
      (reply) => {
        //console.log('Reply : ', reply);
        this.commentService.getFlaggedReplyByUserId(this.id).subscribe(
          (replies) => {
            //console.log('Flasgged Replies : ', replies);
            // this.flagReplyIdList = [];
            // for(let reply of replies.replies){
            //   //console.log(reply);
            //   if(reply.isFlaggedBy.length > 0){
            //     this.flagReplyIdList.push(reply.id);
            //   }
            // }
            //console.log('this.flagReplyIdList', this.flagReplyIdList);
          }
        );
      }
    );
  }
  hideTextField(element, content=null){
    $(element).parents('.feed_commented_text').find('input#editreply').val(content);
    $(element).parents('.feed_commented_text').find('input#editreply').hide();
    $(element).parents('.feed_commented_text').find('span.close-icon').hide();
  }

  showReplyTextField(event) {
    this.isEditReplyEmpty  = false;
    $(event).parents('.feed_commented_text').find('input#editreply').show(200);
    $(event).parents('.feed_commented_text').find('span.close-icon').show();
  }

  onReplySubmit(commentId, activityId) {
    const formData = this.replyForm.value;
    let type;
    //console.log('Reply Submit Data: ' , formData, commentId);

    if(!this.replyForm.valid || _.isUndefined(formData.reply.trim()) || _.isEmpty(formData.reply.trim())){
      this.isFieldEmpty = true;
    }else{
      this.replyForm.reset();
      var reply = formData.reply;
      this.repliesData = {
        content: reply,
        comment: commentId,
        repliedBy: this.id,
        activityFeed: activityId,
      };

      if(this.feedType == 'post' || this.feedType == 'group' || this.feedType == 'recommendation' || this.feedType == 'marketplace'){
        type = 'Activityfeed';
      }else if(this.feedType == 'maintenance'){
        type = 'Maintanance';
        this.repliesData.maintenance = activityId;
      }else if(this.feedType == 'events'){
        this.repliesData.event = activityId;
        type = 'Events';
      }

      this.commentService.saveReply(this.repliesData, type).subscribe(
        (response) => {

          var responseObj = JSON.parse(JSON.stringify(response));
          //console.log(responseObj._body);


          this.percentageService.getUpdatedFeed(this.activityId, this.feedType, false).subscribe((res)=>{});

        }
      );
    }

  }

  onReplyFieldClick(){
    this.isFieldEmpty = false;
    this.isEditReplyEmpty = false;
  }

  onEditReply(replyId, content){

    let type;

    if(this.feedType == 'post' || this.feedType == 'group' || this.feedType == 'recommendation' || this.feedType == 'marketplace'){
      type = 'Activityfeed';
    }else if(this.feedType == 'maintenance'){
      type = 'Maintanance';
    }else if(this.feedType == 'events'){
      type = 'Events';
    }

    if(this.editReplyForm.valid && content != this.editReplyForm.value.comment && this.editReplyForm.value.reply.trim().length > 0){
      console.log('In IF edit reply');
      this.isEditReplyEmpty = false;
      var replyData = {
        id: replyId,
        content: this.editReplyForm.value.reply
      };

      this.commentService.updateReply(replyData, type).subscribe(
        (reply) => {
          if(reply){
            this.commentService.getRepliesByComment(this.commentId, this.initialSkip, this.limit).subscribe(
              (replies) => {
                //console.log('replies for coommmment ID : ' + this.commentId, replies);
                // this.replySubject.next(replies);
                // this.editReplyForm.reset();
              }
            );
          }
        }
      );
    }else {
      console.log('In else edit reply');
      this.isEditReplyEmpty = true;
    }
  }

  onDeleteReply(replyId){

    let type;

        if(this.feedType == 'post' || this.feedType == 'group' || this.feedType == 'recommendation' || this.feedType == 'marketplace'){
          type = 'Activityfeed';
        }else if(this.feedType == 'maintenance'){
          type = 'Maintanance';
        }else if(this.feedType == 'events'){
          type = 'Events';
        }

    //console.log('Reply ID to delete : ' , replyId);
    this.commentService.deleteReply(replyId, type,this.activityId, this.id, this.isManager).subscribe(
      (deleted) => {
        if(deleted.success) {
          this.commentService.getRepliesByComment(this.commentId, this.initialSkip, this.limit).subscribe(
            (replies) => {
              //console.log('replies for Activity ID : ' + this.commentId, replies);
              // this.replySubject.next(replies);
              // this.replyForm.reset();
            }
          );
        }
      }
    );
  }

  refreshData(){
    this.commentService.getRepliesByComment(this.commentId, this.initialSkip, this.limit).subscribe(
      (replies) => {
        //console.log('Replies for Comment ID : ' + this.commentId, replies);
        this.flagReplyUserList = [];
        this.replyData = replies;
        for(let reply of replies){
          for (let flagUser of reply.isFlaggedBy){
            this.flagReplyUserList.push(flagUser.id);
          }
        }
      }
    );
  }

  userUpvote(replyId){

    //console.log(this.feedType,this.activityId, "feed type in upvote method");
    let type;
    if(this.feedType == 'post' || this.feedType == 'group' || this.feedType == 'recommendation' || this.feedType == 'marketplace'){
      type = 'Activityfeed';
    }else if(this.feedType == 'maintenance'){
      type = 'Maintanance';
    }else if(this.feedType == 'events'){
      type = 'Events';
    }

     this.commentService.replyLikes(replyId,  type, this.activityId).subscribe((res)=>{
      //console.log(res);
      this.commentService.getRepliesByComment(this.commentId, this.initialSkip, this.limit).subscribe(
            (replies) => {
              //console.log('replies for Activity ID : ' + this.commentId, replies);
              // this.replySubject.next(replies);
              // this.replyForm.reset();
              this.percentageService.getUpdatedFeed(this.activityId, this.feedType, false).subscribe((res)=>{})
            }
          );
    })
  }

  arrDiff(a1, a2) {
    return a1.concat(a2).filter(function(val, index, arr){
      return arr.indexOf(val) === arr.lastIndexOf(val);
    });
  }

  loadMoreReplies(commentId) {
    this.isLoading = true;
    if(commentId) {
      this.commentService.getAllRepliesByComment(this.commentId).subscribe(
        (allReplies) => {
          this.isLoading = false;
          this.replyData = allReplies;
          this.loadMore = false;
        }
      );
    }
  }

}
